import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// import {makeStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import Validator, { useValidate, checkValidity } from '../../../components/validator';

import SystemService from '../../../data/system-service';
import UsersService from '../../../data/users-service';

// const useStyles = makeStyles(theme => ({
//     buttonRight: {
//         float: 'right',
//         marginLeft: theme.spacing(2),
//     },
// }));

const Request = () => {
    // const classes = useStyles();
    const navigate = useNavigate();
    const [body, setBody] = useState({
        sn: '',
        name: '',
        number: ''
    });
    const [request, setRequest] = useState({
        to_email: 'license-request@bricata.com',
        user_name: '',
    });
    const reqForm = useValidate({});
    const [kick, setKick] = useState(true);

    const handleUpdateBody = (e, validID, valid) => {
        if (validID) {
            reqForm.set({ ...reqForm.get(), [validID]: valid });
        }
        setBody({
            ...body,
            [e.target.name]: e.target.value,
        });
    };

    const handleRequestLicense = () => {
        UsersService.emailSupport({
            ...request,
            body: `S/N: ${body.sn}↵Company Name: ${body.name}↵Contact Number: ${body.number}`,
            subject: 'New License Request from ' + body[1],
        }).then(() => {
            toast.success('License request succesful');
            navigate('/system/license');
        }, err => {
            if (err.message) {
                toast.error(err.message);
            } else {
                toast.error(err);
            }
        });
    };

    const handleCancel = () => {
        navigate('/system/license');
    };

    useEffect(() => {
        SystemService.getLicenseSN().then((res) => {
            setBody({
                ...body,
                sn: res,
            });
        });
        UsersService.getSelf().then((res) => {
            setRequest({
                ...request,
                user_name: res.username
            });
        });
        setKick(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container>
            <Grid item lg={6}>
                <Paper elevation={3}>
                    <Box p={5}>
                        <TextField
                            label="S/N"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            value={body.sn}
                            inputProps={{ name: 'sn' }}
                            onChange={handleUpdateBody}
                        />
                        <Validator
                            errorText="Company name cannot be empty"
                            label="Company Name"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            kick={kick}
                            value={body.name}
                            inputProps={{ name: 'name' }}
                            onChange={handleUpdateBody}
                        />
                        <Validator
                            errorText="Company number cannot be empty"
                            label="Company Number"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            kick={kick}
                            value={body.number}
                            inputProps={{ name: 'number' }}
                            onChange={handleUpdateBody}
                        />
                        <Box mt={2} mb={4} display="flex" justifyContent="flex-end">
                            <Box ml={2}><Button variant="contained" color="inherit" aria-label="Cancel" onClick={handleCancel}>Cancel</Button></Box>
                            <Box ml={2}>
                                <Button
                                    variant="contained"
                                    aria-label="Submit Request"
                                    onClick={handleRequestLicense}
                                    disabled={!checkValidity(reqForm.get())}
                                >
                                    Submit Request
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Request;
